import { render, staticRenderFns } from "./Leave.vue?vue&type=template&id=44b28cf8&"
import script from "./leave.js?vue&type=script&lang=js&"
export * from "./leave.js?vue&type=script&lang=js&"
import style0 from "./leave.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports